/**
 * Represents a time block for a period in a single day in a schedule, currently two per day (standardHours and standardBreak)
 * @param {string} inheritedFrom - The entity level this schedule was inherited from (e.g., "LOCATION")
 * @param {string} startTime - The start time in 24hr format (HH:mm)
 * @param {string} endTime - The end time in 24hr format (HH:mm)
 */
export default class ScheduleTime {
  constructor({ inheritedFrom = '', startTime = null, endTime = null } = {}) {
    this.inheritedFrom = inheritedFrom
    this.startTime = startTime
    this.endTime = endTime
  }
}
